import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const TimeIcon16 = (props: SvgProps) => <Svg
  width={16}
  height={16}
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M8 4.5V8H11.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z'
    stroke='#3379BD'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default TimeIcon16;
